import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { DatePickerModule } from '@progress/kendo-angular-dateinputs';
import { NumericTextBoxModule, TextBoxModule } from '@progress/kendo-angular-inputs';
import { DynamicControlComponent } from 'app/modules/dossier-area/components/dynamic-control/dynamic-control.component';
import { RangeFieldModule } from 'app/shared/components/range-field/range-field.module';
import { ComboboxModule } from 'app/shared/directives/combobox/combobox.module';
import { NotHasRightModule } from 'app/shared/directives/nothasright/nothasright.module';
import { ApiServerUrlPipeModule } from 'app/shared/pipes/api-server-url.pipe.module';
@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    RangeFieldModule,
    NumericTextBoxModule,
    DatePickerModule,
    TextBoxModule,
    TranslateModule,
    NotHasRightModule,
    ComboboxModule,
    ApiServerUrlPipeModule
  ],
  declarations: [DynamicControlComponent],
  exports: [DynamicControlComponent],
})
export class DynamicControlModule {}
